import { createFileRoute } from '@tanstack/react-router';
import { canShowExtratoTemporario } from '@/features/login/util';
import { isPermissionFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/movimentacoes')({
    beforeLoad: () =>
        validateRoute({
            condition: canShowExtratoTemporario([2, 3]),
            fintech: true,
            validatePermission: ({ upp_financeiro_movimentacao }) =>
                isPermissionFull(upp_financeiro_movimentacao),
        }),
});
